import { BiCircle, BiSolidCircle } from "react-icons/bi";
import { PlacesType } from 'react-tooltip';
import './PhoneNumber.scss';

export default function PhoneNumber({
  phone = null,
  dataTooltipPlace = 'top',
  phoneUniqueness = null,
}: {
  phone?: string | null,
  dataTooltipPlace?: PlacesType,
  phoneUniqueness?: string | null,
}) {
  if (typeof phone !== 'string') return <></>
  return <>
    <span className="phone-number-container">
      { phone }
      <span className="phone-uniqueness-icon">
        {
          phoneUniqueness === 'UNIQUE'
            ? <BiSolidCircle
              fontSize={10}
              className="phone-uniqueness-icon--unique"
              data-tooltip-place={dataTooltipPlace}
              data-tooltip-id="main-tooltip"
              data-tooltip-content={`Unique - not shared with any other contact or institution in Edulead`}
              data-tooltip-delay-show={0}
              />
            : null
        }
        {
          phoneUniqueness === 'SHARED_CONTACT'
          || phoneUniqueness === 'SHARED_INSTITUTION'
          || phoneUniqueness === 'SHARED_CONTACT_INSTITUTION'
            ? <BiCircle
              fontSize={10}
              className="phone-uniqueness-icon--shared"
              data-tooltip-place={dataTooltipPlace}
              data-tooltip-id="main-tooltip"
              data-tooltip-content={`Shared - also used by another contact or institution in Edulead`}
              data-tooltip-delay-show={0}
              />
            : null
        }
      </span>
    </span>
  </>
}
